import Partners from './partners'

export default Partners
